import { render, staticRenderFns } from "./app-radio-group.vue?vue&type=template&id=c311f20a&scoped=true&"
import script from "./app-radio-group.vue?vue&type=script&lang=js&"
export * from "./app-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./app-radio-group.vue?vue&type=style&index=0&id=c311f20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c311f20a",
  null
  
)

export default component.exports